import Vue from 'vue'
import SymbolConfig from "../symbol-config"
import articleNoPic from './article_no-pic.vue'
import articleOnePic from './article-one-pic.vue'
import atlas from './atlas.vue'
import list from './list.vue'
import Str from "../../../utils/string"
import { setPicSize } from "../../../utils/pic-util.js"

export const renderRecModule = (el)=>{
    try {
        const type = el?.getAttribute('data-type')
        const content = el?.getAttribute('data-content')
        var dataContent = content && JSON.parse(content) || {};
        let typeMap = {}
        dataContent.spm = getSpm(type)
        dataContent.$el = el
        formatData(type,dataContent)
        getTmplateName(type, dataContent)

       // 根据类型获取模板
        function getTmplateName (type, dataContent) {
            var name = '';
            switch(+type) {
                case SymbolConfig.articleNoPic:
                    render(dataContent,Vue.extend(articleNoPic))
                break;
                case SymbolConfig.articleOnePic:
                    render(dataContent,Vue.extend(articleOnePic))
                break;
                case SymbolConfig.list:
                    render(dataContent,Vue.extend(list))
                break;
                case SymbolConfig.atlas:
                    render(dataContent,Vue.extend(atlas))
                break;
            }
            return name;
        }
        function render(cardInfo,vueConstructor){
            const params = {
				el: document.createElement('div'),
				propsData:{
					cardInfo: cardInfo
				},
			}
            const html = new vueConstructor(params)?.$el
            cardInfo?.$el?.appendChild(html)
        }
        // 格式数据，字数长度，图片裁剪
        function formatData(type, data) {
            var ellipsis = '..';
            if (+type === SymbolConfig.articleNoPic ) {
                var sliceNum = 82;
                data.brief = (data.brief && data.brief.length > sliceNum) ? Str.subString(data.brief, sliceNum) + ellipsis : data.brief
            }
            if ( +type === SymbolConfig.articleOnePic ) {
                var sliceNum = 60;
                data.brief = (data.brief && data.brief.length > sliceNum) ? Str.subString(data.brief, sliceNum) + ellipsis : data.brief;
                data.cover = setPicSize(data.cover, 300, 200);
            }

            if (+type === SymbolConfig.atlas) {
                for (var i = 0; i < 3; i++) {
                    var width = i === 0 ? 194*2 : 97*2
                    var height = i === 0 ? 129*2 : 64*2
                    data.images[i] = setPicSize(data.images[i], width, height);
                }
            }
        }
        // 获取特殊d码
        function getSpm (type) {
            var atricleKey = 'r';
            var atlasKey = 'i';
            var listKey = 'c';
            var key = '';

            if (type == SymbolConfig.articleNoPic || type == SymbolConfig.articleOnePic) {
                key = atricleKey;
            } else if (type == SymbolConfig.atlas) {
                key = atlasKey;
            } else if (type == SymbolConfig.list) {
                key = listKey;
            }
            typeMap[key] = typeMap[key] ? ++typeMap[key] : 1;
            return key + '-' + typeMap[key];
        }
    } catch (error) {
        console.log('推荐卡',error)
    }
}



